/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInviteByTokenDto } from '../models/AcceptInviteByTokenDto';
import type { AllBusinessMembershipsResponse } from '../models/AllBusinessMembershipsResponse';
import type { BusinessMembershipEntity } from '../models/BusinessMembershipEntity';
import type { InvitePreviewResponseDto } from '../models/InvitePreviewResponseDto';
import type { InviteUserDto } from '../models/InviteUserDto';
import type { SigninUserResponseDto } from '../models/SigninUserResponseDto';
import type { UpdateMemberRoleDto } from '../models/UpdateMemberRoleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessMembersService {
    /**
     * List members of the current business
     * @returns AllBusinessMembershipsResponse
     * @throws ApiError
     */
    public static businessMembershipsControllerFindAllV1(): CancelablePromise<AllBusinessMembershipsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business-members',
        });
    }
    /**
     * List pending invitations for the current user
     * @returns AllBusinessMembershipsResponse
     * @throws ApiError
     */
    public static businessMembershipsControllerFindMyInvitationsV1(): CancelablePromise<AllBusinessMembershipsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business-members/my-invitations',
        });
    }
    /**
     * Invite a user to the business
     * @param requestBody
     * @returns BusinessMembershipEntity
     * @throws ApiError
     */
    public static businessMembershipsControllerInviteV1(
        requestBody: InviteUserDto,
    ): CancelablePromise<BusinessMembershipEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/business-members/invite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accept an invitation by token
     * @param requestBody
     * @returns SigninUserResponseDto
     * @throws ApiError
     */
    public static businessMembershipsControllerAcceptByTokenV1(
        requestBody: AcceptInviteByTokenDto,
    ): CancelablePromise<SigninUserResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/business-members/accept-by-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accept an invitation
     * @param memberId Business membership ID
     * @returns BusinessMembershipEntity
     * @throws ApiError
     */
    public static businessMembershipsControllerAcceptInvitationV1(
        memberId: string,
    ): CancelablePromise<BusinessMembershipEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/business-members/{memberId}/accept',
            path: {
                'memberId': memberId,
            },
        });
    }
    /**
     * Update member role
     * @param memberId Business membership ID
     * @param requestBody
     * @returns BusinessMembershipEntity
     * @throws ApiError
     */
    public static businessMembershipsControllerUpdateRoleV1(
        memberId: string,
        requestBody: UpdateMemberRoleDto,
    ): CancelablePromise<BusinessMembershipEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/business-members/{memberId}/role',
            path: {
                'memberId': memberId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove member from business
     * @param memberId Business membership ID
     * @returns void
     * @throws ApiError
     */
    public static businessMembershipsControllerRemoveV1(
        memberId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/business-members/{memberId}',
            path: {
                'memberId': memberId,
            },
        });
    }
    /**
     * Preview an invitation by token (public)
     * @param token Invite token
     * @returns InvitePreviewResponseDto
     * @throws ApiError
     */
    public static publicInvitesControllerGetInvitePreviewV1(
        token: string,
    ): CancelablePromise<InvitePreviewResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business-members/invite-preview/{token}',
            path: {
                'token': token,
            },
        });
    }
}
